/* import __COLOCATED_TEMPLATE__ from './prism-selector-card.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';
const KEYCODE_SPACE = 32;

/**
 * This component is a card that acts like a selector. If clicked, it will send
 * its value to the onSelect() callback.
 *
 * @param {any} value - The value this selector selects when clicked
 * @param {any} selectedValue - The value currently selected. If this matches the
 *   selector's value, the selector will consider itself currently selected
 * @param {function} onSelect - The callback for when this selector is selected
 * @param {string} cardId - The ID to give to the main card/button element
 * @param {boolean} showCheck - Show a checkmark when card is selected
 *
 */
export default Component.extend({
  value: null,
  selectedValue: null,
  showCheck: false,
  onSelect() {},
  cardId: null,
  tabindex: 0,
  role: 'radio',
  isSelected: computed('selectedValue', 'value', function () {
    return this.selectedValue === this.value;
  }),
  buttonClasses: computed('showCheck', 'isSelected', function () {
    const selectedClass = this.isSelected ? 'prism-selector-card--selected' : 'prism-selector-card--unselected';
    const showCheckClass = this.showCheck ? 'prism-selector-card--with-check' : '';
    return `prism-selector-card ${selectedClass} ${showCheckClass}`;
  }),
  select() {
    this.onSelect(this.value);
  },
  /**
   * @param {KeyboardEvent} event
   */
  selectWithKey(event) {
    if (event.keyCode === KEYCODE_SPACE) {
      this.select();
      event.preventDefault();
    }
  }
});